import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Button from 'material-ui/Button';
import classNames from 'classnames';
import KeymanAttribute from '../parts/KeymanAttribute';
import { TimelineLabelType } from "../../../constants/ComponentTypes";
import moment from "moment";

const styles = () => ({
  root: {
    borderBottom: "1px solid #D8DBDF",
    boxSizing: "border-box",
    padding: "15px 20px 15px 0px",
    width: "100%",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  order: {
    display: 'flex',
    alignItems: 'center',
  },

  timeline: {
    display: 'flex',
    width: "334px",
    justifyContent: 'space-around',
  },

  status: {
    display: 'flex',
    width: "50%",
    justifyContent: 'space-around',
  },

  update: {
    display: 'flex',
    width: "50%",
    justifyContent: 'space-around',
  },

  btn: {
    padding: '10px 18px',
    height: "33px",
    width: "115px",
    borderRadius: "2px",
    fontSize: "13px",
  },

  btnEnable: {
    border: "1px solid #1A65FF",
    background: "#FFFFFF",
    color: "#1A65FF",
    "&:hover": {
      background: "#1A65FF",
      color: '#FFFFFF',
    },
  },
});

class OrderAddressItem extends React.Component {
  render() {
    const { classes, item, key } = this.props;
    const target = Object.values(TimelineLabelType).find(label => label.value === item.latest_timeline_status.status_label_type);
    let color, timelineLabel;
    if (target) {
      color = target.color;
      timelineLabel = target.text;
    }

    return (
      <div className={classes.root} key={key}>
        <KeymanAttribute item={item} style={{ width: "293px", marginRight: "87px" }} />
        <div className={classes.timeline}>
          <div className={classes.status}>
            <Typography className={classes.timelineLabel} style={{ color: color }}>
              {timelineLabel}
            </Typography>
          </div>
          <div className={classes.update}>
            <Typography>
              {moment(item.latest_timeline_status.created_at).format("YYYY/MM/DD") + "更新"}
            </Typography>
          </div>
        </div>
        <Button className={classNames(classes.btn, classes.btnEnable)}
          onClick={() => {
            this.props.goTo(
              `${item.executive_person_id
                ? "/executive-list/" + item.executive_person_id
                : "/house-list/" + item.address_id
              }/timeline`
            );
          }}
        >
          タイムライン
        </Button>
      </div>
    );
  }
}

OrderAddressItem.propTypes = {
  classes: PropTypes.object.isRequired,
  key: PropTypes.number,
  item: PropTypes.object,
  goTo: PropTypes.func.isRequired,
};

export default withStyles(styles)(OrderAddressItem);



// WEBPACK FOOTER //
// ./src/components/OrderDetail/items/OrderAddressItem.jsx